export default "__VITE_ASSET__45f995d2__"